(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
      // Custom expandable predictive search
      (() => {
        const search = document.getElementById('category-bar-search');
        const toggle = document.getElementById('category-bar-search-toggle');
        const form = document.getElementById('category-bar-search-form');
        const input = document.getElementById('category-bar-search-input');
        const close = document.getElementById('category-bar-search-close');
        const results = document.getElementById('category-bar-search-results');

        if (!toggle || !form || !input || !close || !results) return;

        let timer;
        let controller;

        const RECENTLY_VIEWED_KEY = 'recently_viewed_products';

        const escapeHtml = (value) => {
          const div = document.createElement('div');
          div.textContent = value || '';
          return div.innerHTML;
        };

        const getRecentlyViewed = () => {
          try {
            const stored = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY));
            return Array.isArray(stored) ? stored : [];
          } catch (error) {
            return [];
          }
        };

        const clearRecentlyViewed = () => {
          try {
            localStorage.removeItem(RECENTLY_VIEWED_KEY);
          } catch (error) {
            /* noop */
          }
          results.hidden = true;
          results.innerHTML = '';
        };

        const renderRecentlyViewed = () => {
          const items = getRecentlyViewed();

          if (!items.length) {
            results.hidden = true;
            results.innerHTML = '';
            return;
          }

          const rows = items.map((product) => {
            const image = product.image
              ? `<img class="category-bar-search__result-image" src="${escapeHtml(product.image)}" alt="">`
              : '';
            const description = product.description
              ? `<span class="category-bar-search__result-desc">${escapeHtml(product.description)}</span>`
              : '';

            return `
              <a class="category-bar-search__result" href="${escapeHtml(product.url)}">
                ${image}
                <span class="category-bar-search__result-info">
                  <span class="category-bar-search__result-title">${escapeHtml(product.title)}</span>
                  ${description}
                  <span class="category-bar-search__result-price">${escapeHtml(product.price || '')}</span>
                </span>
              </a>
            `;
          }).join('');

          results.innerHTML = `
            <div class="category-bar-search__results-header">
              <span>Recently viewed</span>
              <button type="button" class="category-bar-search__clear" id="category-bar-search-clear">Clear</button>
            </div>
            ${rows}
          `;

          results.hidden = false;

          const clearBtn = document.getElementById('category-bar-search-clear');
          if (clearBtn) clearBtn.addEventListener('click', clearRecentlyViewed);
        };

        const searchPlaceholder = document.createComment('tool-sorcerer-search-placeholder');
        search.parentNode.insertBefore(searchPlaceholder, search);

        const centerSearchDesktop = () => {
          if (window.innerWidth < 990 || !search.classList.contains('is-open')) return;

          const header = document.querySelector('.header');
          if (!header) return;

          const headerRect = header.getBoundingClientRect();
          const searchHeight = 52;

          /* Fixed position is calculated from the real header position, but the
             search itself lives directly under <body>, so no ancestor can clip it. */
          search.style.left = '50%';
          search.style.top = `${Math.max(8, headerRect.top + ((headerRect.height - searchHeight) / 2))}px`;
        };

        const openSearch = () => {
          if (window.innerWidth >= 990 && search.parentNode !== document.body) {
            document.body.appendChild(search);
            search.classList.add('is-desktop-portal');
          }

          search.classList.add('is-open');
          document.body.classList.add('search-is-open');
          toggle.setAttribute('aria-expanded', 'true');
          centerSearchDesktop();
          input.focus();

          if (!input.value.trim()) {
            renderRecentlyViewed();
          }
        };

        const closeSearch = () => {
          search.classList.remove('is-open');
          document.body.classList.remove('search-is-open');
          toggle.setAttribute('aria-expanded', 'false');
          search.style.left = '';
          search.style.top = '';
          results.hidden = true;
          results.innerHTML = '';
          input.value = '';
          if (controller) controller.abort();

          if (search.classList.contains('is-desktop-portal')) {
            search.classList.remove('is-desktop-portal');
            if (searchPlaceholder.parentNode) {
              searchPlaceholder.parentNode.insertBefore(search, searchPlaceholder.nextSibling);
            }
          }
        };

        const showResults = (products) => {
          if (!products.length) {
            results.innerHTML = '<div class="category-bar-search__result-empty">No products found.</div>';
            results.hidden = false;
            return;
          }

          results.innerHTML = products.map((product) => {
            const image = product.image
              ? `<img class="category-bar-search__result-image" src="${escapeHtml(product.image)}" alt="">`
              : '';

            return `
              <a class="category-bar-search__result" href="${escapeHtml(product.url)}">
                ${image}
                <span class="category-bar-search__result-info">
                  <span class="category-bar-search__result-title">${escapeHtml(product.title)}</span>
                  <span class="category-bar-search__result-price">${escapeHtml((product.tags || []).includes('stocked-soon') ? 'Stocked soon' : (product.price || ''))}</span>
                </span>
              </a>
            `;
          }).join('');

          results.hidden = false;
        };

        const predictiveSearch = async () => {
          const query = input.value.trim();

          if (controller) controller.abort();

          if (query.length < 2) {
            if (!query) {
              renderRecentlyViewed();
            } else {
              results.hidden = true;
              results.innerHTML = '';
            }
            return;
          }

          controller = new AbortController();

          try {
            const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku,vendor`;

            const response = await fetch(url, {
              signal: controller.signal,
              headers: { Accept: 'application/json' }
            });

            if (!response.ok) throw new Error('Predictive search failed');

            const data = await response.json();
            const products = data.resources?.results?.products || [];

            showResults(products);
          } catch (error) {
            if (error.name !== 'AbortError') {
              results.hidden = true;
            }
          }
        };

        toggle.addEventListener('click', openSearch);
        close.addEventListener('click', closeSearch);

        const cartIcon = document.getElementById('cart-icon-bubble');
        if (cartIcon) {
          cartIcon.addEventListener('pointerdown', () => {
            if (search.classList.contains('is-open')) closeSearch();
          }, true);
        }

        input.addEventListener('input', () => {
          clearTimeout(timer);
          timer = setTimeout(predictiveSearch, 180);
        });

        window.addEventListener('resize', centerSearchDesktop);

        document.addEventListener('click', (event) => {
          const cartTarget = event.target.closest(
            '#cart-icon-bubble, cart-drawer, .cart-drawer, .cart-notification, cart-notification'
          );

          // Never interfere with clicks inside the cart.
          // Only close the custom search when the cart icon itself is clicked.
          if (cartTarget) {
            if (
              cartTarget.id === 'cart-icon-bubble' &&
              search.classList.contains('is-open')
            ) {
              closeSearch();
            }

            return;
          }

          // Only close the custom search when it is actually open
          // and the click happened outside it.
          if (
            search.classList.contains('is-open') &&
            !search.contains(event.target)
          ) {
            closeSearch();
          }
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && search.classList.contains('is-open')) {
            closeSearch();
          }
        });


        form.addEventListener('submit', () => {
          results.hidden = true;
        });
      })();

      class StickyHeader extends HTMLElement {
        constructor() {
          super();
          this.setHeaderHeight = this.setHeaderHeight.bind(this);
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header');
          this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
          this.headerIsAlwaysSticky =
            this.getAttribute('data-sticky-type') === 'always' ||
            this.getAttribute('data-sticky-type') === 'reduce-logo-size';
          this.headerBounds = {};

          this.setHeaderHeight();

          this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          }

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearches = this.querySelectorAll('predictive-search');

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (this.preventHide) return;
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
          if (this.headerIsAlwaysSticky) return;
          this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
          this.closeMenuDisclosure();
          this.closeSearchModal();
        }

        reveal() {
          if (this.headerIsAlwaysSticky) return;
          this.header.classList.add('shopify-section-header-sticky', 'animate');
          this.header.classList.remove('shopify-section-header-hidden');
        }

        reset() {
          if (this.headerIsAlwaysSticky) return;
          this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
          this.disclosures.forEach((disclosure) => disclosure.close());
        }

        closeSearchModal() {
          this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
          this.searchModals.forEach((searchModal) => searchModal.close(false));
        }
      }

      // The account `open` event is composed but does not bubble, so listen during capture.
      // Anchor the dialog to the bottom of the account button itself. The header group can be
      // much taller than the button's row (for example, a top-left logo pushes the menu to a
      // second row), so anchoring to the section bottom drops the dialog too low.
      document.addEventListener(
        'open',
        (event) => {
          if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

          const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
          event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
        },
        true
      );

      customElements.define('sticky-header', StickyHeader);
    
  } catch(e) { console.error(e); }
})();
})();
